var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var io = require('../../libs/socketio');
var loaders = require('../../layout/components/loaders');
var button = require('../../components/button');
var commentModal = require('./commentAlarmModal');
var dragscroll = require('../../libs/dragscroll');
var modal = require('../../layout/components/modal');
var pagination = require('../../data/components/pagination');

var dateFormat = 'MM-DD-YYYY hh:mm:ss.SSSS a';

var component = {};

component.oninit = function (vnode) {
  var ctrl = this;
  ctrl.point = vnode.attrs.pointRecord;
  ctrl.column = vnode.attrs.column;

  if (ctrl.column && ctrl.column['@rid']) {
    ctrl.column = ctrl.column['@rid'];
  }

  ctrl.form = {
    start: prop(null),
    span: prop(24)
  };

  var data = {};
  if (ctrl.form.start()) {
    data['start'] = moment(ctrl.form.start(), dateFormat).valueOf();
  }
  else {
    data['start'] = moment().valueOf();
  }
  data['span'] = ctrl.form.span();

  ctrl.getIncidents = function(){
    loaders.requestWithLoader({
      url: '/api/v1/point/' + String(ctrl.point['@rid']).slice(1) + '/incidents',
      body: data,
      method: 'GET'
    }).then(function(result){
      ctrl.events = result;
    })
  }
  ctrl.getIncidents();
    
  ctrl.noData = function () {
    //console.log(Boolean(ctrl.events.length))
    return Boolean(ctrl.events.length)
  }

  modal.on('closed', function () {
    ctrl.events = []
    ctrl.getIncidents();
  });

  const handleCommentCreated = function (payload) {
    if (!payload) return;
    if (
      payload.subjectRecord && 
      payload.subjectRecord.out_Of &&
      Array.isArray(payload.subjectRecord.out_Of) &&
      payload.subjectRecord.out_Of.some(r => r.in && r.in['@rid'] === ctrl.point['@rid'])
      
    ) {
      ctrl.getIncidents();
      m.redraw();
    } 
  };

  io.on('comment-event', handleCommentCreated);
};

component.view = function() {
  var ctrl = this
  if (!ctrl.events){
    return m('div')
  }
  return m('div.mv1', [
    m('div.dragscroll-container', {display: ctrl.noData() ? "block" : "none"}, [
      m('div.dragscroll.pb3', {oncreate:dragscroll}, [
        m('table.fw2.f3.w-100.pr3', [
          m('thead', [
            m('tr.db.relative', [
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'min-width': '280px'}},'Timestamp'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'min-width': '160px'}},'Event Type'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'min-width': '160px'}},'Acknowledged'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'min-width': '160px'}},'Acknowledged By'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'min-width': '160px'}},'Snapshot'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'width': '100%'}},'Description'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {'min-width': '100px'}},'Comments'),
            ])
          ]),
          m('tbody.db', {style: {height: '16em'}}, [
            ctrl.events.map(function (eventRecord) {
              if (!eventRecord.out_SubjectOf)
                eventRecord.out_SubjectOf=[]
              return m('tr.db', [
                m('td.bb.tl.moon-gray.tl.nowrap', {style: {'min-width': '280px'}}, moment(eventRecord.timestamp).format(dateFormat)),
                m('td.bb.tl.moon-gray.tl.nowrap', {style: {'min-width': '162px'}}, eventRecord.type),
                m('td.bb.tl.moon-gray.tl.nowrap', {style: {'min-width': '162px'}}, [
                  eventRecord.acknowledged == 1 ?  
                    m('i.ml2.ion-android-checkbox-outline.green.pointer') 
                  : 
                    m('i.ml2.ion-android-checkbox-outline-blank.gray.pointer')
                ]),
                m('td.bb.tl.moon-gray.tl.nowrap', {style: {'min-width': '162px'}}, [
                  eventRecord.acknowledgedBy ? eventRecord.acknowledgedBy : ''
                ]),
                m('td.bb.tl.moon-gray.tl.nowrap', {style: {'min-width': '162px'}}, (function () {
                  if (eventRecord.snapshot == 'available') {
                      return m(m.route.Link, {
                          class:'btn btn-primary',
                          type:'button',
                          href: '/snapshot/' + eventRecord['@rid'].slice(1)
                      }, 'View')
                  } else if (eventRecord.snapshot == 'Error Retrieving Snapshot') {
                    return 'Error';
                  } else {
                    return eventRecord.snapshot
                  }
                })()),
                m('td.bb.tl.moon-gray.tl.nowrap', {'width': '100%'}, eventRecord.name),
                m('td.bb.tl.moon-gray.tl.nowrap',{style: {'min-width': '102px', 'text-align':'center'}},[
                   m('i.ion-android-chat.blue.ml1.pointer', {
                     onclick: function () {
                         return commentModal.editDialogue.call(commentModal, eventRecord);
                     } 
                   },"     "+eventRecord.out_SubjectOf.length || 0),
                ])
              ])
            })
          ])
        ]),
        (()=>{
          if(ctrl.events.length >0){
            return m(pagination, {data: ctrl.events})
          }
        })(),
      ]),
    ]),
    m('div.flex.justify-center', [
      m('p.tc.mw7', 
      {style:{color:'#ddd',display: ctrl.noData() ? "none" : "block"}}, 
      'No data was found for the range selected.'
      )
    ]),
  ]);
}

module.exports = component;
